import { AxiosResponse } from 'axios'

import { WorkPattern, WorkPatternContent } from 'types/workPattern'

import { _axios } from './axios'

const FILTER_BY_SECURITY_FIELD = (securityFieldId: string) =>
  `/work_patterns/${securityFieldId}`
const CREATE = (securityFieldId: string) => `/work_patterns/${securityFieldId}`
const UPDATE = '/work_patterns/update'
const BULK_DELETE = (securityFieldId: string) =>
  `/work_patterns/bulk_delete/${securityFieldId}`

export const workPatternApi = () => {
  const filterBySecurityField = async (
    securityFieldId: string,
  ): Promise<
    AxiosResponse<{
      workPatterns: WorkPattern[]
    }>
  > => {
    return await _axios().get(FILTER_BY_SECURITY_FIELD(securityFieldId))
  }

  const create = async (securityFieldId: string, data: WorkPatternContent) => {
    return await _axios().post(CREATE(securityFieldId), data)
  }

  const update = async (
    id: string,
    securityFieldId: string,
    data: WorkPatternContent,
  ) => {
    const workPattern: WorkPattern = {
      id,
      securityFieldId,
      ...data,
    }
    return await _axios().put(UPDATE, workPattern)
  }

  const bulkDelete = async (
    securityFieldId: string,
    data: {
      workPatternIds: string[]
    },
  ) => {
    return await _axios().delete(BULK_DELETE(securityFieldId), {
      data,
    })
  }

  return {
    filterBySecurityField,
    create,
    update,
    bulkDelete,
  }
}
